import {useFormatNumber} from 'platform/locale';
import {match, Pattern} from 'ts-pattern';

import {useState} from 'react';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

export function useOfferButtonLabel(count: number | undefined, isLoading: boolean) {
  const formatNumber = useFormatNumber();
  const [lastCount, setLastCount] = useState<number | undefined>(count);
  if (!isLoading && isNotNil(count) && count !== lastCount) {
    setLastCount(count);
  }
  // Button overlays its spinner on the label. Keep the label width during a recount.
  const displayedCount = isLoading ? lastCount : count;
  return match({displayedCount, isLoading})
    .with({displayedCount: Pattern.number}, ({displayedCount}) =>
      i18n.t('page.filters.actions.showOffersWithCount', {
        count: displayedCount,
        formattedCount: formatNumber(displayedCount, 0),
      })
    )
    .with({isLoading: true}, () => i18n.t('general.labels.loading'))
    .otherwise(() => i18n.t('general.errors.invalidParams'));
}
